import { render } from "./PlotlyPlot.vue?vue&type=template&id=4350ff7c"
import script from "./PlotlyPlot.vue?vue&type=script&lang=js"
export * from "./PlotlyPlot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__